<!-- ? V2 1XP -->

<script lang="ts">
type Props = {
  image: string;
  title: string;
  copy?: string;
  primaryLink?: string;
};
</script>

<script setup lang="ts">
const emit = defineEmits(['clicked']);
defineProps<Props>();
</script>

<template>
  <figure :class="$style.container" @click="emit('clicked')">
    <a v-if="primaryLink" :class="$style.mediaLink" :href="primaryLink">
      <img alt="" :src="image" />
    </a>
    <a v-else :class="$style.mediaLink">
      <img alt="" :src="image" />
    </a>
    <figcaption>
      <a v-if="primaryLink" :href="primaryLink">
        <span>{{ title }}</span>
        <div v-if="copy">
          {{ copy }}
        </div>
      </a>
      <a v-else>
        <span>{{ title }}</span>
        <div v-if="copy">
          {{ copy }}
        </div>
      </a>
    </figcaption>
  </figure>
</template>

<style module lang="scss">
@forward './ContentOverviewTeaser.scss';
</style>
